import React from "react";

import type { SelectionOptions } from "../../types/selections";
import type { ProcessedSelection } from "@/hooks/firestore/betting/useEntries";

import {
  isExoticSelection,
  isSameEventMultiSelection,
  isSingleSelection,
} from "../../util/type-guards";
import { SingleSelection } from "../selections/SingleSelection";
import { ExoticSelection } from "../selections/ExoticSelection";
import { SameEventMultiSelection } from "../selections/SameEventMultiSelection";

interface SelectionContainerProps {
  entryId: number;
  isShared: boolean;
  selection: ProcessedSelection;
  isFirst: boolean;
  isLast: boolean;
  isCombo?: boolean;
  isDecided: boolean;
  isEntryWon: boolean;
  isCashedOut: boolean;
  isPreview?: boolean;
  hasMultipleSelections?: boolean;
  createdAt: string;
  connectUp?: boolean;
  connectDown?: boolean;
}

const BetEntrySelection = ({
  entryId,
  isShared,
  selection,
  isFirst,
  isLast,
  isCombo = false,
  isDecided,
  isEntryWon,
  isCashedOut,
  isPreview,
  hasMultipleSelections,
  createdAt,
  connectUp = false,
  connectDown = false,
}: SelectionContainerProps) => {
  const isSelectionWon = selection.result === "WIN";
  const isVoid = selection.result === "VOID";

  const options: SelectionOptions = {
    isSelectionWon,
    isEntryWon,
    isCombo,
    isVoid,
    isFirst,
    isLast,
    isCashedOut,
    isDecided,
    connectUp,
    connectDown,
  };

  if (isSingleSelection(selection)) {
    return (
      <SingleSelection
        entryId={entryId}
        isShared={isShared}
        selection={selection}
        options={options}
        isPreview={isPreview}
        createdAt={createdAt}
      />
    );
  }

  if (isSameEventMultiSelection(selection)) {
    return (
      <SameEventMultiSelection
        entryId={entryId}
        isShared={isShared}
        selection={selection}
        isLast={isLast}
        isFirst={isFirst}
        createdAt={createdAt}
        isEntryWon={isEntryWon}
        hasMultipleSelections={hasMultipleSelections}
      />
    );
  }

  if (isExoticSelection(selection)) {
    return (
      <ExoticSelection
        entryId={entryId}
        isShared={isShared}
        selection={selection}
        options={options}
        isPreview={isPreview}
        createdAt={createdAt}
      />
    );
  }

  return null;
};

export { BetEntrySelection };
